import { useMultiuserContext } from "@solidwhite/multiuser";

import LocationSynchronizer from "./LocationSynchronizer";
import store from "../../appStore";
import { useEffect } from "react";
import CursorCollider from "./CursorCollider";
import PresentatorCursor, { RemotePresentatorCursor } from "./PresentatorCursor";
import CameraWrapper from "../3d/CameraWrapper";
import RemoteCamera from "./RemoteCamera";
import MultiuserCursors, { OwnCursor } from "./MultiuserCursors";
import PresentatorAwarenessSender from "./PresentatorAwarenessSender";

const Synchronizers = ({ ...props }) => {
  const { connected, spectating, presenting } = useMultiuserContext();

  useEffect(() => {
    store.multiuser.connected = connected;
  }, [connected]);

  useEffect(() => {
    store.multiuser.spectating = spectating;
  }, [spectating]);

  return (
    <>
      <CameraWrapper enabled={!connected || presenting} />
      {connected && (
        <>
          {presenting && (
            <>
              <PresentatorCursor />
              <PresentatorAwarenessSender />
            </>
          )}
          {spectating && (
            <>
              <RemoteCamera />
              <RemotePresentatorCursor />
              <OwnCursor />
            </>
          )}
          <MultiuserCursors />
          <CursorCollider />
          <LocationSynchronizer />
        </>
      )}
    </>
  );
};

export default Synchronizers;
